export default {
  appSettings: 'Nastavenia aplikácie',
  userSettings: 'Nastavenia používateľa',
  tenantSettings: 'Nastavenia Qmulus',
  APIKey: 'API kľúče',
  notificationChannel: 'Kanály notifikácií',
  userSubscription: 'Predplatné používateľov',
  channels: 'Kanály',
  reportBuilder: 'Tvorca správ',
  assetParameterDefinition: 'Definície parametrov zariadenia',
  pinnedApps: 'Pripnuté aplikácie',
};
